module.exports = __webpack_public_path__ + "img/tasks_add.55a91d25.svg";